'use client'

import { type ReactNode } from 'react'
import { SWRConfig } from "swr";

const fetcher = async (url: string) =>
  await fetch(url).then(async (r) => await r.json())

export default function Providers({ children }: { children: ReactNode }) {
  return (
    <SWRConfig value={{ fetcher }}>
      {children}
    </SWRConfig>
  )
}
